
export default class DetalleEncargoCreadorBuilder {
  static build({
    cdgtipo, linea, descripcion, estructuraId, obligatorio, unidades, etiqueta, numeroLote,
  }) {
    let eliminable = true;
    if (estructuraId !== undefined || estructuraId || null) {
      eliminable = false;
    }
    let cadenaTipo = 'Articulo';
    if (cdgtipo === 1) {
      cadenaTipo = 'Lente';
    } else if (cdgtipo === 3) {
      cadenaTipo = 'Montura';
    } else if (cdgtipo === 5) {
      cadenaTipo = 'Sol';
    }
    return {
      cdgtipo,
      cadenaTipo,
      linea,
      numeroLote: numeroLote || null,
      descripcion,
      estructuraId,
      obligatorio,
      unidades,
      etiqueta,
      eliminable,
    };
  }
}
